import React from 'react';

const ChatHistory = ({ sessions, loading, onSelectSession }) => (
    <div className="roxy-panel__history">
        {loading ? (
            <div className="roxy-panel__history-empty">Loading...</div>
        ) : sessions.length === 0 ? (
            <div className="roxy-panel__history-empty">No closed chats</div>
        ) : (
            sessions.map((session) => (
                <div
                    key={session.sessionId}
                    className="roxy-panel__history-item"
                    onClick={() => onSelectSession(session)}
                >
                    Session #{session.sessionId}
                </div>
            ))
        )}
    </div>
);

export default ChatHistory;
